/**
 * index.js — Application Entry Point
 * ─────────────────────────────────────────────────────
 * CHANGES:
 *  1. Cleaned up duplicate bootstrap CSS imports (was importing both .css and .min.css)
 *  2. Organized imports by category
 *  3. Storage check error message styled consistently
 */

// Polyfills (must be first)
import 'babel-polyfill';
import 'react-app-polyfill/ie9';

// React
import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { Provider } from 'react-redux';

// Third-party CSS & JS
import 'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

// App CSS
import './assets/css/style.css';

// Store
import { store, persistor } from './store/configureStore';

// Components
import App from './App';
import ErrorBoundary from './components/utilComponents/ErrorBoundary';
import * as serviceWorker from './serviceWorker';

// Utilities
import { initializeStorage } from './util/storageHelper';

if (!initializeStorage()) {
  document.getElementById('root').innerHTML =
    '<div style="text-align:center;padding:50px;font-family:sans-serif;">' +
    '<h2>Storage Error</h2>' +
    '<p>Please enable cookies and local storage, then reload the page.</p>' +
    '</div>';
} else {
  ReactDOM.render(
    <ErrorBoundary>
      <PersistGate persistor={persistor}>
        <Provider store={store}>
          <App />
        </Provider>
      </PersistGate>
    </ErrorBoundary>,
    document.getElementById('root')
  );
}

serviceWorker.unregister();
